import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { user } from './user';
import { reducer as reduxForm } from 'redux-form';

export default combineReducers({user, form: reduxForm});

export const getUser = createSelector(state =>  state.user, user => user);